import type { PropsWithChildren } from 'react'

interface ContainerProps extends PropsWithChildren {
  className?: string
}

export const AccountSummaryStats = ({ children }: ContainerProps) => (
  <div className="flex gap-1 justify-between overflow-x-auto">{children}</div>
)
